export const InitialValuesCustomerBank = {
  name: "",
  iban: "",
  bic: ""
};
